/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

// Function to handle adding or removing items from the cart
function add_to_cart_grid(variantid, qty) {
    toggleCartItemState(variantid, qty);
}

// pick your free perfume below -- window load check btns
window.addEventListener('load', function () {
    var allBtn = document.querySelectorAll('.cart-offer-items .product-item .cart-offer-atc');
    var itemRemoveBtnFound = false; // Flag to check if item-remove button is found

    // Check if any button has the 'item-remove' class
    allBtn.forEach(function (btn) {
        if (btn.classList.contains('item-remove')) {
            itemRemoveBtnFound = true; 
        }
    });

    // If at least one item-remove button is found
    if (itemRemoveBtnFound) {
        allBtn.forEach(function (btn) {
            if (!btn.classList.contains('item-remove')) {
                btn.disabled = true; 
                btn.innerHTML = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg> Disabled`;
            }
        });
    } else {
        // If no 'item-remove' button is found, do not disable any button
        allBtn.forEach(function (btn) {
            btn.disabled = false;
        });
    }
});

const upsellProduct = [
  '49261297795355', '49261316145435', '46705262362907', '46705277796635', '49668439474459', '49668434985243'
];

// Toggles the state of the cart button between "Add" and "Remove"
function toggleCartItemState(variantid, qty) {
  const cartItem = document.querySelector(`.cart-offer-items .product-item[data-product-id="${variantid}"]`);
  if (!cartItem) {
    return; // Exit if the cart item is not found
  }

  const btn = cartItem.querySelector('.cart-offer-atc');
  const allBtn = document.querySelectorAll('.cart-offer-atc');

  if (btn.classList.contains('item-remove')) {
    // Remove item from cart
    allBtn.forEach(button => {
      button.disabled = false;
      button.innerHTML = `
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20">
          <path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path>
        </svg> Add`;
      button.classList.remove('item-remove');
    });

    removeItemFromCart(variantid);
    handleCartOperations();
    document.dispatchEvent(new CustomEvent('cart:build'));
  } else {
    // Fetch the cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Check if any upsellProduct is in the cart
        const hasUpsellProduct = cart.items.some(item => upsellProduct.includes(item.id.toString()));

        if (!hasUpsellProduct) {
          // Disable all other buttons and update the clicked button
          allBtn.forEach(button => {
            button.disabled = true;
            button.innerHTML = `
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20">
                <path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path>
              </svg> Disabled`;
          });

          // Enable the clicked button and add the product to the cart
          btn.disabled = false;
          addItemToCart(variantid, qty);
          btn.innerHTML = `
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20">
              <path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029z"></path>
            </svg> Remove`;
          btn.classList.add('item-remove');
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
}

// Function to add an item to the cart via AJAX
function addItemToCart(variantid, qty) {
    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ quantity: qty, id: variantid })
    })
        .then(response => response.json())
        .then(() => {

            handleCartOperations();

            // Initialize and open the cart drawer after the updates
            var cart = new theme.CartDrawer;
            cart.init();
            cart.open();

        })
        .catch(error => {
            console.error('Error adding item to cart:', error);
        });
}

// Function to remove an item from the cart via AJAX
function removeItemFromCart(productSKU) {
    if (!productSKU || isNaN(productSKU)) {
        return; 
    }

    var requestData = {
        id: productSKU.toString(), 
        quantity: 0 
    };

    return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData)
    })
        .then(response => response.json())
        .then(() => {
            document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(error => {
            console.error('Error removing item from cart:', error);
        });
}

// Function to handle all cart-related operations including fetching the cart, handling upsell products, calculating savings, and managing the free gift
// Function to format money
function formatMoney(amount) {
    const amountInRs = amount / 100;
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amountInRs);
}

// Function to fetch product details
function fetchProductDetails(variantId) {
    return fetch(`/variants/${variantId}.js`)
        .then(response => response.json());
}

// Function to get the current cart data
function getCart() {
    return fetch('/cart.js')
        .then(response => response.json())
        .catch(error => {
            console.error('Error fetching cart data:', error);
            return {}; 
        });
}

// Function to remove all upsell products
async function removeAllUpsellProducts(upsellProductIds) {
    const removalPromises = upsellProductIds.map(productId => {
        return new Promise((resolve) => {
            removeItemFromCart(productId);

            const removeButton = document.querySelector(`.cart-offer-items .product-item[data-product-id="${productId}"] .cart-offer-atc.item-remove`);
            if (removeButton) {
                removeButton.click();
            }

            setTimeout(() => resolve(), 500);
        });
    });

    await Promise.all(removalPromises);

    const closeButton = document.querySelector('.drawer__close-button.js-drawer-close');
    if (closeButton) {
        closeButton.click();
    }
}

let isAddingGift = false;  // Flag to prevent duplicate adds

// Function to calculate total MRP and total savings
function calculateMoneyAndSavings(cart, variants) {
    let totalMRP = 0;
    let totalSavings = 0;

    variants.forEach(variant => {
        const item = cart.items.find(item => item.variant_id === variant.id);
        if (!item) return;

        totalMRP += variant.compare_at_price * item.quantity;

        if (variant.compare_at_price > variant.price) {
            const itemSavings = (variant.compare_at_price - variant.price) * item.quantity;
            totalSavings += itemSavings;
        }
    });

    return { totalMRP, totalSavings };
}

// Function to update the DOM with total money and savings
function updateMoneyAndSavings(totalMRP, totalSavings) {
    document.getElementById('total-mrp').textContent = formatMoney(totalMRP);
    // document.getElementById('total-savings').textContent = `-${formatMoney(totalSavings)}`;
}

// Main function to handle cart operations
function handleCartOperations() {
    getCart().then(cart => {

        const upsellProductIds = ['49261297795355', '49261316145435', '49261322404123', '49261325287707', '46705262362907', '49393113760027', '47355478278427','49521366171931','49521386815771','46705277796635','49668439474459','49668434985243'];
        let cartItemTotal = 0;
        let upsellItemQuantities = {};

        const fetchPromises = cart.items.map(item => fetchProductDetails(item.variant_id));

        Promise.all(fetchPromises).then(variants => {

            const { totalMRP, totalSavings } = calculateMoneyAndSavings(cart, variants);
            updateMoneyAndSavings(totalMRP, totalSavings);

            variants.forEach(variant => {
                const item = cart.items.find(item => item.variant_id == variant.id);

                if (!upsellProductIds.includes(item.id.toString())) {
                    cartItemTotal += item.quantity;
                } else {
                    upsellItemQuantities[item.id.toString()] = item.quantity;
                }
            });

            if (cartItemTotal < 1) {
                removeAllUpsellProducts(upsellProductIds).catch(error => console.error('Error removing upsell products:', error));
            } else {
                upsellProductIds.forEach(productId => {
                    const quantity = upsellItemQuantities[productId] || 0;
                    if (quantity === 0) {
                        const removeButton = document.querySelector(`.cart-offer-items .product-item[data-product-id="${productId}"] .cart-offer-atc.item-remove`);
                        if (removeButton) {
                            removeButton.click();
                        }
                    }
                });
            }
        });
    }).catch(error => {
        console.error('Error handling cart operations:', error);
    });
}

// Event listener for custom cart update event
document.addEventListener('cart:updated', function(e) {
    if (e.detail && e.detail.cart && Array.isArray(e.detail.cart.items_removed)) {
        if (e.detail.cart.items_removed.length > 0) {
            var cartItems = document.querySelector('.drawer__contents .cart__items');
            if (cartItems) {
                var upsellCount = parseInt(cartItems.getAttribute('data-upsell-count')) || 0;
                var totalItemCount = parseInt(cartItems.getAttribute('data-count')) || 0;
                var sellCount = totalItemCount - upsellCount;

                if (parseInt(sellCount) <= 1 && parseInt(upsellCount) >= 1) {
                    var cart = new theme.CartDrawer();
                    cart.init(); // Refresh the cart
                }
            } else {
                console.error('Cart items element not found.');
            }
        }
    } else {
        console.error('Cart update event details are missing or not in expected format.');
    }

    handleCartOperations();

}, false);

// Event listener for page load to check cart totals
window.addEventListener('load', function () {
    handleCartOperations();
});

// for product page
document.addEventListener('DOMContentLoaded', function () {
    // Select all product forms
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

    addToCartForms.forEach(function (form) {

        //form submission event
        form.addEventListener('submit', function (event) {

            const formData = new FormData(form);
            const variantId = formData.get('id');
            const qty = formData.get('quantity') || 1;

            addItemToCart(variantId, qty);
        });
    });
});
